import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine_rate_success",
  "use": "icon-mine_rate_success-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-mine_rate_success\"><g fill=\"none\" fill-rule=\"evenodd\" opacity=\".25\"><path d=\"M0 0h28v28H0z\" /><path d=\"M14 25.667C7.556 25.667 2.333 20.443 2.333 14 2.333 7.556 7.556 2.333 14 2.333S25.667 7.556 25.667 14 20.443 25.667 14 25.667Zm-1.94-6.223 8.247-8.25-1.65-1.649-6.598 6.6-3.3-3.3-1.65 1.65 4.95 4.95Z\" fill=\"#0FBA57\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol